import { Trash2, Clock, TrendingDown, AlertTriangle } from "lucide-react";

const stats = [
  {
    icon: Trash2,
    stat: "88%",
    label: "of business cards are thrown away within 1 week",
    color: "text-destructive",
    bgColor: "bg-destructive/10",
  },
  {
    icon: Clock,
    stat: "48hrs",
    label: "is all it takes for someone to forget your conversation",
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
  },
  {
    icon: TrendingDown,
    stat: "0%",
    label: "of paper cards include your photo for instant recognition",
    color: "text-white/60",
    bgColor: "bg-white/5",
  },
  {
    icon: AlertTriangle,
    stat: "$0",
    label: "is what a lost connection costs them. But for you? Everything.",
    color: "text-primary",
    bgColor: "bg-primary/10",
  },
];

const BrutalTruthSection = () => {
  return (
    <section className="py-24 bg-slate-950">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-destructive/20 text-destructive text-sm font-semibold mb-4 border border-destructive/30">
            The Brutal Truth
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            This is What Happens to{" "}
            <span className="text-destructive">Your Business Card</span>
          </h2>
          <p className="text-lg text-white/50">
            You hand someone your card. They smile, pocket it, and promise to call. Here's what actually happens next.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((item, index) => (
            <div
              key={index}
              className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 rounded-xl ${item.bgColor} flex items-center justify-center mb-4`}>
                <item.icon className={`w-6 h-6 ${item.color}`} />
              </div>
              <p className={`text-4xl font-bold ${item.color} mb-2`}>{item.stat}</p>
              <p className="text-white/60 text-sm leading-relaxed">{item.label}</p>
            </div>
          ))}
        </div>

        {/* The Story */}
        <div className="max-w-4xl mx-auto">
          <div className="relative bg-gradient-to-r from-destructive/10 to-transparent rounded-3xl p-8 md:p-12 border border-destructive/20">
            <div className="absolute top-0 left-8 -translate-y-1/2">
              <span className="px-4 py-1.5 rounded-full bg-destructive text-white text-sm font-semibold">
                The Vanishing Act
              </span>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 mt-4">
              <div>
                <h3 className="text-xl font-bold text-white mb-4">What you think happens:</h3>
                <p className="text-white/60 leading-relaxed">
                  "They'll save my number. They'll reach out when they need me. 
                  I made a great impression — they won't forget."
                </p>
              </div>
              <div>
                <h3 className="text-xl font-bold text-destructive mb-4">What actually happens:</h3>
                <p className="text-white/60 leading-relaxed">
                  Your card ends up crumpled in a drawer, lost in a bag, or tossed in the trash within 48 hours. 
                  The conversation you had? <span className="text-white">Gone.</span> The deal you could've closed? 
                  <span className="text-white"> Evaporated.</span> You're not even a memory — 
                  <span className="text-destructive font-semibold"> you're invisible.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrutalTruthSection;
